export const colorGold = '#cca34e';
